import React, { ButtonHTMLAttributes, FC } from "react";

type TButtonProps = {
  onClick: () => void;
  children: React.ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button: FC<TButtonProps> = ({ onClick, children, ...props }) => {
  return (
    <button
      className="bg-dark px-4 py-2 rounded-lg text-white hover:bg-black"
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
